import { Component, computed, input, type Signal } from '@angular/core';
import { TypedComponentRendering } from '@core/jss-models';
import type { SimpleProgressiveFormCardContent } from '@innogy/common-ui/progressive-forms';
import type { ProgressiveFormGroupState } from '@innogy/progressive-ngrx-forms';
import type { KeyValue } from 'ngrx-forms';

import type {
  OrderContent,
  ScOrderFields,
} from '../order-fulfillment-container.model';

@Component({
  selector: 'wl-order-fulfillment-step',
  template: '',
})
export abstract class OrderFulfillmentStepComponent<
  TFormValues extends KeyValue,
> {
  readonly rendering = input.required<TypedComponentRendering<ScOrderFields>>();
  readonly orderContent = input.required<OrderContent>();
  readonly stepNumber = input.required<number>();
  readonly progressiveFormState =
    input.required<ProgressiveFormGroupState<TFormValues>>();

  readonly formState = computed(() => this.progressiveFormState().formState);

  abstract readonly progressiveFormCardContent: Signal<SimpleProgressiveFormCardContent>;
}
